import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const AreasOfDifference = () => {
  const { t } = useTranslation();
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in');
          observer.unobserve(entry.target);
        }
      },
      {
        threshold: 0.2
      }
    );

    const currentElement = sectionRef.current;
    if (currentElement) {
      observer.observe(currentElement);
    }

    return () => {
      if (currentElement) {
        observer.unobserve(currentElement);
      }
    };
  }, []);

  const features = [
    {
      key: 'innovation',
      image: "/images/11.jpg",
      isLarge: true
    },
    {
      key: 'global',
      image: "/images/bgnavy.png"
    },
    {
      key: 'delivery',
      image: "/images/22.jpg",
      isLarge: true
    },
    {
      key: 'expertise',
      image: "/images/bgnavy.png"
    },
    {
      key: 'customer',
      image: "/images/33.jpg",
      isFullWidth: true
    }
  ];

  return (
    <section 
      className="py-20 bg-white" 
      id="degerler"
    >
      <div 
        ref={sectionRef}
        className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 opacity-0 transition-opacity duration-1000 ease-out"
      >
        {/* Header */}
        <div className="text-center pb-16 mb-16 border-b border-gray-200">
          <div className="flex items-center justify-center mb-5">
            <div className="w-4 h-4 rounded-full bg-primaryBlue flex-shrink-0"></div>
            <h6 className="text-md font-medium text-black ltr:ml-2 rtl:mr-2">{t('difference.subtitle')}</h6>
          </div>
          <h2 className="text-4xl font-semibold text-gray-900 mb-4 bg-gradient-to-r from-[#1365c4] to-[#141e51] text-transparent bg-clip-text">
            {t('difference.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {t('difference.description')}
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature) => (
            <div 
              key={feature.key}
              className={`relative rounded-2xl overflow-hidden transition-transform duration-300 hover:translate-y-[-8px] ${
                feature.isLarge ? 'lg:col-span-2' : ''
              } ${feature.isFullWidth ? 'md:col-span-2 lg:col-span-3' : ''} ${
                feature.textOnly ? 'bg-slate-800' : ''
              }`}
              style={{ height: '400px' }}
            >
              {!feature.textOnly && (
                <>
                  <img 
                    src={feature.image} 
                    alt={t(`difference.features.${feature.key}.title`)}
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                  {/* Gradient Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-black/20"></div>
                </>
              )}
              <div className="absolute inset-0 p-8 flex flex-col justify-end">
                <h3 className="text-2xl font-semibold text-white mb-3">
                  {t(`difference.features.${feature.key}.title`)}
                </h3>
                <p className="text-gray-200 leading-relaxed">
                  {t(`difference.features.${feature.key}.description`)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AreasOfDifference; 